<script lang="ts">
  import type { PageProps } from './$types';

  import GradientBackgroundWrapper from '$components/common/GradientBackgroundWrapper.svelte';
  import ContentPageHero from '$components/common/Heros/ContentPageHero.svelte';
  import Definition from '$components/pages/organismes-de-foncier-solidaire/Definition.svelte';
  import Role from '$components/pages/organismes-de-foncier-solidaire/Role.svelte';
  import Proximity from '$components/pages/organismes-de-foncier-solidaire/Proximity.svelte';
  import OfsList from '$components/pages/organismes-de-foncier-solidaire/OfsList.svelte';
  import { formatOfss } from '$lib/utils/formatters';
  import Synthesis from '$components/pages/organismes-de-foncier-solidaire/Synthesis.svelte';

  const { data }: PageProps = $props();

  const ofss = data.ofss.items;
  const formattedOfss = formatOfss(ofss);
</script>

<svelte:head>
  <title>OFS : définition, rôle, actions et liste - Boris</title>
  <meta
    name="description"
    content="OFS : découvrez les missions d'un OFS, ses actions, comprenez le lien OFS-BRS et identifiez les OFS proches de chez vous. " />
</svelte:head>

<GradientBackgroundWrapper>
  <ContentPageHero title="Les OFS : à quoi servent-ils, où les trouver ?">
    <span></span>
  </ContentPageHero>
  <Definition />
  <Role />
  <Proximity />
  <OfsList regions={formattedOfss} />
  <Synthesis />
</GradientBackgroundWrapper>
